import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isJwtLive } from '../api';
import { getAdminJwt } from '../auth';

export default function AdminGuard({ children }: { children: ReactNode }) {
  // The admin JWT lives under its own key ('learnwithai_admin_jwt', via
  // getAdminJwt) — NOT under 'learnwithai_admin_session', which holds the admin
  // user OBJECT. Validating the session object as a JWT always fails, which
  // bounced every admin straight back to /admin/login (regression from the
  // 2026-06-17 hardening that added isJwtLive but kept the wrong key).
  const token = getAdminJwt();
  return isJwtLive(token) ? <>{children}</> : <Navigate to="/admin/login" replace />;
}
